<template>
  <SeverityModal
    isMarkdown
    :notificationMessage="deleteEmmNotificationMessage"
    :notificationTitle="deleteInfo.alert"
    :numberAffectedProp="randomNumberValidator"
    :primaryButtonProps="primaryButtonProps"
    :showCloseButton="false"
    :showModal="true"
    :title="deleteInfo.title"
    useInputNumber
    variant="sev3"
    @close="handleCancelRegistration"
    @save="handleDeleteRegistration"
  >
    <template v-slot:subtitle>
      <span>{{ deleteInfo.text }}</span>
    </template>
    <template v-slot:learnmore>
      <ParagraphBody>
        For more information,
        <Link
          isExternal=""
          text="link to help doc"
        />
        or email
        <Link
          href="http://jumpcloud.com"
          text="Support."
        />
      </ParagraphBody>
    </template>
    <template v-slot:list>
      <ParagraphBody>
        <span>
          To proceed, enter <strong>{{ randomNumberValidator }}</strong> in the below input box.
        </span>
      </ParagraphBody>
    </template>
  </SeverityModal>
</template>

<script>
import {
  AndroidEmmConsts, ItemTypeConsts, StoreModuleMap,
} from 'client/util/Constants';
import {
  Link,
  ParagraphBody,
  SeverityModal,
  Types,
} from '@jumpcloud/ui-components';
import { mapActions, mapState } from 'vuex';
import { notificationModuleName as notificationModule } from '@jumpcloud/ui-notifications';

const googleModule = StoreModuleMap[ItemTypeConsts.mdmGoogle];
const { PrimaryButtonProps } = Types;

export default {
  name: 'GoogleEmmDeleteRegistration',

  components: {
    Link,
    ParagraphBody,
    SeverityModal,
  },

  data: () => ({
    deleteInfo: AndroidEmmConsts.androidEmmDeleteRegistrationText,
    randomNumberValidator: 111111,
  }),

  computed: {
    ...mapState(googleModule, [
      'googleEmmEnterpriseObj',
    ]),

    deleteEmmNotificationMessage() {
      return `Deleting your registration cannot be undone. If you choose to proceed the following will occur, and you will need to re-enroll from the starting point.

    • Your enrolled devices will be un-enrolled (wiped and/or factory reset).

    • Your created policies will be purged. Your added applications will be removed.
    `;
    },

    primaryButtonProps() {
      return PrimaryButtonProps({
        isDisabled: false,
        isLoading: false,
        hasOutline: true,
        text: 'Delete',
        type: 'error',
      });
    },
  },

  mounted() {
    this.randomNumberValidator = Math.floor(100000 + Math.random() * 900000);
  },

  methods: {
    ...mapActions(googleModule, [
      'updateEnrollState',
      'deleteEnterprise',
    ]),
    ...mapActions(notificationModule, [
      'triggerErrorNotification',
      'triggerSuccessNotification',
    ]),

    handleCancelRegistration() {
      this.$emit('cancel-delete-registration-confirmation');
    },

    async handleDeleteRegistration() {
      try {
        await this.deleteEnterprise(
          this.googleEmmEnterpriseObj.enterpriseObjectId,
        );
        this.triggerSuccessNotification({
          title: 'Success',
          message: 'Enterprise deleted successfully.',
        });
        this.updateEnrollState(false);
      } catch {
        this.triggerErrorNotification({
          title: 'Error',
          message: 'There is a problem deleting enterprise.',
        });
        this.$emit('cancel-delete-registration-confirmation');
      }
    },
  },
};
</script>
